import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CounselorCommunication = ({ child, onMessageSend }) => {
  const [message, setMessage] = useState('');
  const [selectedTopic, setSelectedTopic] = useState('');

  const mockMessages = [
    {
      id: 1,
      sender: 'counselor',
      senderName: 'Mme Ndiaye',
      message: 'Bonjour, ' + child?.name + ' progresse très bien dans son parcours d\'orientation. Je recommande de continuer les quiz de découverte.',
      timestamp: '2026-02-10T14:30:00',
      read: true
    },
    {
      id: 2,
      sender: 'parent',
      senderName: 'Vous',
      message: 'Merci pour le retour. Quelles sont les prochaines étapes recommandées ?',
      timestamp: '2026-02-10T15:45:00',
      read: true
    },
    {
      id: 3,
      sender: 'counselor',
      senderName: 'Mme Ndiaye',
      message: 'Je suggère de planifier une session familiale pour discuter des options universitaires adaptées à son profil.',
      timestamp: '2026-02-11T09:15:00',
      read: true
    }
  ];

  const topicOptions = [
    { value: 'progress', label: 'Progression académique' },
    { value: 'recommendations', label: 'Recommandations de filières' },
    { value: 'session', label: 'Planification de session' },
    { value: 'concerns', label: 'Préoccupations' },
    { value: 'other', label: 'Autre sujet' }
  ];

  const handleSendMessage = () => {
    if (message?.trim() && selectedTopic) {
      onMessageSend?.();
      setMessage('');
      setSelectedTopic('');
    }
  };

  const formatTimestamp = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-sm overflow-hidden">
      <div className="bg-gradient-to-r from-blue-500 to-purple-500 p-6">
        <div className="flex items-center gap-3 text-white">
          <Icon name="MessageSquare" size={28} />
          <div>
            <h2 className="text-xl font-semibold">Communication avec le Conseiller</h2>
            <p className="text-sm text-blue-100">Concernant: {child?.name}</p>
          </div>
        </div>
      </div>

      <div className="p-6">
        {/* Counselor Info */}
        <div className="bg-blue-50 rounded-lg p-4 mb-6 border border-blue-200">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
              <Icon name="UserCheck" size={24} color="#FFFFFF" />
            </div>
            <div className="flex-1">
              <h3 className="text-base font-semibold text-gray-900">Mme Ndiaye</h3>
              <p className="text-sm text-gray-600">Conseillère d'Orientation</p>
            </div>
            <Button
              variant="outline"
              size="sm"
              iconName="Calendar"
            >
              Planifier RDV
            </Button>
          </div>
        </div>

        {/* Message History */}
        <div className="mb-6">
          <h3 className="text-base font-semibold text-gray-900 mb-4">Historique des Messages</h3>
          <div className="space-y-4 max-h-96 overflow-y-auto">
            {mockMessages?.map((msg) => (
              <div
                key={msg?.id}
                className={`flex gap-3 ${
                  msg?.sender === 'parent' ? 'flex-row-reverse' : 'flex-row'
                }`}
              >
                <div
                  className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${
                    msg?.sender === 'counselor' ?'bg-blue-500' :'bg-purple-500'
                  }`}
                >
                  <Icon
                    name={msg?.sender === 'counselor' ? 'UserCheck' : 'User'}
                    size={20}
                    color="#FFFFFF"
                  />
                </div>
                <div
                  className={`flex-1 max-w-md ${
                    msg?.sender === 'parent' ? 'text-right' : 'text-left'
                  }`}
                >
                  <div
                    className={`inline-block rounded-lg p-4 ${
                      msg?.sender === 'counselor' ?'bg-gray-100 text-gray-900' :'bg-blue-500 text-white'
                    }`}
                  >
                    <p className="text-sm font-medium mb-1">{msg?.senderName}</p>
                    <p className="text-sm">{msg?.message}</p>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    {formatTimestamp(msg?.timestamp)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* New Message Form */}
        <div className="border-t border-gray-200 pt-6">
          <h3 className="text-base font-semibold text-gray-900 mb-4">Nouveau Message</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Sujet du message
              </label>
              <select
                value={selectedTopic}
                onChange={(e) => setSelectedTopic(e?.target?.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">Sélectionnez un sujet</option>
                {topicOptions?.map((topic) => (
                  <option key={topic?.value} value={topic?.value}>
                    {topic?.label}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Votre message
              </label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e?.target?.value)}
                rows={4}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Écrivez votre message ici..."
              />
            </div>

            <Button
              variant="default"
              iconName="Send"
              iconPosition="right"
              onClick={handleSendMessage}
              disabled={!message?.trim() || !selectedTopic}
              fullWidth
            >
              Envoyer le Message
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounselorCommunication;